<template>
  <page title="Edit Ads " backTo="/ads" size="is-desktop">
    <div slot="page-header-right">
      <b-dropdown position="is-bottom-left">
        <button class="button" slot="trigger">
          <b-icon icon="dots-horizontal"></b-icon>
        </button>
        <b-dropdown-item @click="destroy()">
          <span>Delete</span>
        </b-dropdown-item>
      </b-dropdown>
    </div>

    <form @submit.prevent="handleSubmit" v-if="form">
      <div class="columns">
        <div class="column is-4">
          <div class="box">
            <b-field label="ADS type">
              <b-select placeholder="Choose a type" v-model="form.type" expanded>
                <option value="html">HTML</option>
                <option value="pdf">PDF</option>
                <option value="image">Image</option>
                <option value="video">Video</option>
              </b-select>
            </b-field>
          </div>

          <div class="box">
            <b-field label="ADS fit">
              <b-select placeholder="Choose a fit" v-model="form.fit" expanded>
                <option value="height">Height</option>
                <option value="width">Width</option>
              </b-select>
            </b-field>
          </div>

          <div class="box">
            <div v-if="screenShot.path">
              <img style="max-width: 150px;" :src="screenShot.url" />
              <hr />
            </div>

            <div v-else-if="adsContent.screenshot_path">
              <img style="max-width: 150px;" :src="adsContent.screenshot_url" />
            </div>

            <b-field>
              <upload-image
                endpoint="/admin/api/adses/media"
                file-field-name="image"
                :additional="{
                  prefix: 'images/adses/screenshot_path',
                  format: 'jpg'
                }"
                @uploaded="i => screenShot = i"
              >
                <button
                  type="button"
                  class="button is-primary is-outlined is-small"
                  slot="trigger"
                >Upload Screenshot Image</button>
              </upload-image>
            </b-field>
          </div>
        </div>

        <div class="column is-8">
          <div class="box">
            <b-field label="ADS name">
              <b-input placeholder="ASD name" v-model="form.name"></b-input>
            </b-field>
          </div>

          <div class="box">
            <div>
              <div v-if="image.path">
                <img :src="image.url" v-if="adsContent.type == 'image'" />

                <div v-else-if="adsContent.type == 'pdf'">
                  {{image.path}}
                  <br />
                  <a :href="image.url" type="button" class="button" target="_blank">Preview</a>
                </div>

                <div v-else-if="adsContent.type == 'url'">
                  {{ image.path }}
                  <a :href="image.url" target="_blank">Show</a>
                </div>

                <video v-else-if="adsContent.type == 'video'" width="100%" controls>
                  <source :src="image.url" type="video/mp4" width="100%" />
                </video>
                <hr />
              </div>
              <div v-else-if="adsContent.path">
                <img :src="adsContent.url" v-if="adsContent.type == 'image'" />

                <div v-else-if="adsContent.type == 'pdf'">
                  {{adsContent.path}}
                  <br />
                  <a :href="adsContent.url" type="button" class="button" target="_blank">Preview</a>
                </div>

                <div v-else-if="adsContent.type == 'html'">
                  {{ adsContent.path }}
                  <a :href="adsContent.url" target="_blank">Show</a>
                </div>

                <video v-else-if="adsContent.type == 'video'" width="100%" controls>
                  <source :src="adsContent.url" type="video/mp4" width="100%" />
                </video>
                <hr />
              </div>
            </div>
            <div v-if="form.type == 'image'">
              <b-field label="Image upload">
                <upload-image
                  endpoint="/admin/api/adses/media"
                  file-field-name="image"
                  :additional="{
                    prefix: 'ads/pages/images',
                    format: 'jpg'
                  }"
                  @uploaded="i => image = i"
                >
                  <button
                    type="button"
                    class="button is-primary is-outlined is-small"
                    slot="trigger"
                  >Upload Image</button>
                </upload-image>
              </b-field>
            </div>
            <div v-else-if="form.type == 'pdf'">
              <b-field label="PDF upload">
                <upload-pdf
                  endpoint="/admin/api/adses/media"
                  file-field-name="pdf"
                  :additional="{
                    prefix: 'ads/pages/pdfs',
                    format: 'pdf'
                  }"
                  @uploaded="i => image = i"
                >
                  <button
                    type="button"
                    class="button is-primary is-outlined is-small"
                    slot="trigger"
                  >Upload PDF File</button>
                </upload-pdf>
              </b-field>
            </div>

            <b-field v-else-if="form.type == 'video'" label="Video upload">
              <upload-video
                endpoint="/admin/api/adses/media"
                file-field-name="video"
                :additional="{
                  prefix: 'ads/pages/video',
                  format: 'mp4'
                }"
                @uploaded="i => image = i"
              >
                <button
                  type="button"
                  class="button is-primary is-outlined is-small"
                  slot="trigger"
                >Upload video</button>
              </upload-video>
            </b-field>

            <b-field v-else-if="form.type == 'html'" label="HTML upload">
              <upload-html
                endpoint="/admin/api/adses/media"
                file-field-name="zip"
                :additional="{
                  prefix: 'ads/pages/zips',
                  format: 'zip'
                }"
                @uploaded="i => image = i"
              >
                <button
                  type="button"
                  class="button is-primary is-outlined is-small"
                  slot="trigger"
                >Upload Zip</button>
              </upload-html>
            </b-field>

            <b-field v-else label="Select an ADS type"></b-field>
          </div>
        </div>
      </div>

      <div class="box">
        <modal-opener
          :component="require('./components/CreateServing.vue').default"
          :props="{ adsContent: adsContent, whenUpdated: () => load() }"
        >
          <button class="button mr-1" type="button" slot="trigger">Add new serving</button>
        </modal-opener>

        <hr />

        <div class="card-content is-paddingless">
          <b-table :data="adsContent.servings" class="is-middle">
            <template slot-scope="props">
              <b-table-column field="option_title" label="Option" width="300">
                <div v-if="props.row.option_type == 'magazine'">Magazine: {{props.row.option.name}}</div>
                <div
                  v-else-if="props.row.option_type == 'magazine-category'"
                >Category: {{props.row.option.title}}</div>
                <div
                  v-else-if="props.row.option_type == 'magazine-issue'"
                >Issue: {{props.row.option.title}}</div>
                <div v-else-if="props.row.option_type == 'all'">All magazine</div>
              </b-table-column>

              <b-table-column field="page_number" label="Page">
                {{ props.row.page_number_strategy === 'start_from_current_page' ? '+' : ''}}
                {{ props.row.page_number }}
              </b-table-column>

              <b-table-column field="start_date" label="Start">
                <b-tooltip :label="props.row.start_date">{{ props.row.start_date | date }}</b-tooltip>
              </b-table-column>

              <b-table-column field="end_date" label="End">
                <b-tooltip :label="props.row.end_date">{{ props.row.end_date | date }}</b-tooltip>
              </b-table-column>

              <b-table-column field="edit">
                <div class="is-pulled-right">
                  <modal-opener
                    :component="require('./components/EditServing.vue').default"
                    :props="{ serving: props.row, whenUpdated: () => load() }"
                  >
                    <button class="button mr-1" type="button" slot="trigger">Edit</button>
                  </modal-opener>

                  <b-button
                    type="button"
                    @click="destroyServing(props.row.id)"
                    class="button mr-1 is-danger is-outlined"
                  >Delete</b-button>
                </div>
              </b-table-column>
            </template>
          </b-table>
        </div>
      </div>
      <hr />
      <div class="is-pulled-right">
        <router-link to="/ads" class="button" :disabled="form.processing">Cancel</router-link>

        <button class="button is-primary" :class="{ 'is-loading': form.processing }">
          <b-icon icon="content-save"></b-icon>
          <span>Save</span>
        </button>
      </div>
    </form>
  </page>
</template>

<script>
import UploadImage from "./../../components/UploadImage";
import UploadVideo from "./../../components/UploadVideo";
import UploadHtml from "./../../components/UploadHtml";
import UploadPdf from "./../../components/UploadPdf";
import moment from "moment";

export default {
  components: {
    UploadImage,
    UploadVideo,
    UploadHtml,
    UploadPdf
  },

  data() {
    return {
      processing: false,
      banner: null,
      form: new window.Form({
        name: null,
        type: null,
        path: null,
        screenshot_path: this.adsContent ? this.adsContent.screenshot_path : "",
        fit: null
      }),
      image: {
        url: null,
        path: null
      },
      screenShot: {
        url: null,
        path: null
      },
      adsContent: null,
      magazine: null,
      issue: null,
      category: null
    };
  },

  created() {
    this.load();
  },

  watch: {
    image() {
      this.form.path = this.image.path;
    },
    screenShot() {
      this.form.screenshot_path = this.screenShot.path;
    }
  },

  methods: {
    load() {
      this.$http
        .get("/admin/api/adses/" + this.$route.params.id)
        .then(response => {
          this.adsContent = response.data.data;
          this.form.name = this.adsContent.name;
          this.form.type = this.adsContent.type;
          this.form.path = this.adsContent.path;
          this.form.screenshot_path = this.adsContent.screenshot_path;
          this.form.fit = this.adsContent.fit;
        })
        .catch(() => {
          alert("Couldn't fetch data from the server.");
        });
    },

    handleSubmit() {
      this.processing = true;
      this.form
        .put("/admin/api/adses/" + this.$route.params.id)
        .takeAtLeast(500)
        .then(() => {
          this.$buefy.toast.open({
            type: "is-success",
            message: "Successfully saved."
          });

          this.$emit("saved", this.form);
          this.load();
        });
    },

    destroy() {
      this.$buefy.dialog.confirm({
        title: "Deleting ADS?",
        message: "Warning the deleted data wouldn't restore.",
        cancelText: "Cancel",
        confirmText: "Delete ADS",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          this.$http
            .delete("/admin/api/adses/" + this.$route.params.id)
            .then(() => {
              this.$buefy.toast.open("ADS deleted.");
              this.$router.push("/ads");
            })
            .catch(error => {
              new window.FailedResponseHandler(error).handle();
            });
        }
      });
    },

    calculate(date) {
      return moment(date).fromNow();
    },

    destroyServing(id) {
      this.$buefy.dialog.confirm({
        title: "Deleting serving?",
        message: "Warning the deleted data wouldn't restore.",
        cancelText: "Cancel",
        confirmText: "Delete Serving",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          this.$http
            .delete("/admin/api/servings/" + id)
            .then(() => {
              this.$buefy.toast.open("ADS Serving deleted.");
              this.load();
            })
            .catch(error => {
              new window.FailedResponseHandler(error).handle();
            });
        }
      });
    }
  }
};
</script>
